import { render, staticRenderFns } from "./ChiaviChain.vue?vue&type=template&id=14728822&scoped=true"
import script from "./ChiaviChain.vue?vue&type=script&lang=js"
export * from "./ChiaviChain.vue?vue&type=script&lang=js"
import style0 from "./ChiaviChain.vue?vue&type=style&index=0&id=14728822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14728822",
  null
  
)

export default component.exports